import _ from "lodash";
import embeddingService, { hostOrigin } from "services/embeddingService";
import featureToggleService, {
    FeatureToggle,
} from "services/featureToggleService";
import {
    isFullUrl,
    getDecodedQueryParamsFromUri,
    getDecodedQueryParamsFromWindow,
    setQueryParams,
    hashify,
} from "util/uriUtil";

function useNewAnalyticsRoute() {
    return featureToggleService.isEnabled(
        FeatureToggle.REC_5171_USE_NEW_ANALYTICS_ROUTE
    );
}

export default {
    navigateTo(newPath, options, preserveQueryParams = true) {
        const queryParams = {
            ...getDecodedQueryParamsFromWindow(),
            ...getDecodedQueryParamsFromUri(newPath),
        };
        const pathWithParams = preserveQueryParams
            ? setQueryParams(newPath, queryParams)
            : newPath;

        options = _.assign({ newWindow: false }, options);
        const url = isFullUrl(pathWithParams)
            ? pathWithParams
            : this.asHostUrl(hashify(pathWithParams));
        embeddingService.requestNavigation(url, options);
    },

    redirectTo(newPath) {
        const url = isFullUrl(newPath)
            ? newPath
            : this.asHostUrl(hashify(newPath));
        embeddingService.requestRedirect(url);
    },

    /**
     * Build a host hash for an interaction route.
     * When FT REC-5171_useNewAnalyticsRoute is ON:  #/analytics/interactions/{id}/{context}/{path}
     * When FT is OFF:                                #/engage/{context}/interactions/{id}/{path}
     *
     * @param {string} context - 'admin' or 'agent'
     * @param {string} conversationId
     * @param {string} [path] - optional sub-path (e.g. 'details', 'qualitySummary/?evaluationId=...'), to produce url with trailing slash pass an empty string.
     * @returns {string}
     */
    buildInteractionHash(context, conversationId, path) {
        if (useNewAnalyticsRoute()) {
            return path != undefined
                ? `#/analytics/interactions/${conversationId}/${context}/${path}`
                : `#/analytics/interactions/${conversationId}/${context}`;
        }
        return path != undefined
            ? `#/engage/${context}/interactions/${conversationId}/${path}`
            : `#/engage/${context}/interactions/${conversationId}`;
    },

    asHostHash(localHash) {
        const [hash, context, conversationId, ...rest] = localHash.split("/");
        if (useNewAnalyticsRoute()) {
            return [
                hash,
                "analytics",
                "interactions",
                conversationId,
                context,
                ...rest,
            ].join("/");
        }
        return [
            hash,
            "engage",
            context,
            "interactions",
            conversationId,
            ...rest,
        ].join("/");
    },

    asHostUrl(hostHash) {
        const baseHostUrl = embeddingService.asHostUrl("").split("#")[0];
        return `${baseHostUrl}${hostHash}`;
    },
};
